export default __webpack_public_path__ + "static/media/bnbminter-logo-green.c578d105.png";